import { useQuery } from "@tanstack/react-query";

import { getAdminAllPractices, getAllPractices } from "services";

import { DEFAULT_CACHE_TIME, GET_PRACTICES } from "consts";

export const useGetPractices = (isAdmin = false) =>
  useQuery({
    queryKey: [GET_PRACTICES, isAdmin],
    queryFn: isAdmin ? getAdminAllPractices : getAllPractices,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
